import styled from "@emotion/styled";

import { minMedia } from "@styles";
import { theme } from "@styles/constants";

export const StyledRating = styled.span`
  display: inline-block;

  width: 32px;
  height: 32px;
  svg {
    margin: 0 auto;
    horizontal-align: middle;
    stroke: ${theme.black};
  }

  ${minMedia.mediumScreen`
    display: inline-block;

  `};
`;
